// i18n.js
import { ca } from 'date-fns/locale';
import i18n from 'i18next';
import { reverse } from 'lodash';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      navbar: {
        venderCompany: 'Company/Vendor',
        taxId: 'Tax ID',
        custNo: 'Customer No.',
        custName: 'Customer Name',
      },
      app: {
        welcome: 'Welcome',
        attachment:'Attachment',
        sendEmail:'Send Email',
        selectDocument: 'Select Document',
        invoiceNumber: 'Invoice Number',
        verifyDocument: 'Verify Document',
        verifyingDocuments: 'Verifying documents',
        confirmSubmission: 'Confirm Submission',
        sendEmailTo: 'Send email to :',
        emailAttachmentWarning: 'All invoice items must have supporting documents attached before you can send the email.',
        sequence: 'No.',
        documentStatus: 'Status',
        noAttachment: 'No attachment',
        back: 'Back',
        invoicePrepaid: 'Invoice/Prepaid',
        prePaid: 'Pre-Paid',
        postPaid: 'Post-Paid',
        all: 'All',
        service: 'Service',
        quotationNo: 'Quotation No.',
        bookbankNoStatment: 'BookBank No.',
        quotation: 'Quotation',
        paymentType: 'Payment Type',
        statusPayment: 'Status Payment',
        startDate: 'Start Date',
        endDate: 'End Date',
        search: 'Search',
        eDoc: 'E-Documents',
        function: 'Function',
        uploadSlip: 'UPLOAD SLIP',
        payment: ' PAYMENT',
        sendmail: 'SEND E-MAIL',
        unpaid: 'Unpaid',
        paid: 'Paid',
        pending: 'Pending',
        overdue: 'Overdue',
        eDocuments: 'E-Documents',
        eInvoice: 'E-INVOICE',
        amountMoneyThb: 'Amount (THB)',
        eReceipt: 'E-RECEIPT',
        managePayments: 'Manage Payments',
        toPay: 'To Pay',
        uploadSlip: 'Upload Slip',
        payment: 'Payment',
        selected: 'Selected ',
        items: 'items',
           approvedDate: 'Approved Date',
        rejectedDate: 'Rejected Date',
        reverseSuccess: 'Reverse Success',
        invoiceNo: 'Invoice No.',
        period: 'Period',
        saleOrder: 'Sale Order',
        quotation: 'Quotation',
        serviceName: 'Service',
        invoiceDate: 'Invoice Date',
        startDate: 'Start Date',
        endDate: 'End Date',
        dueDate: 'Due Date',
        grandAmountThb: 'Grand Amount (THB)',
        grandAmount: 'Grand Amount',
        creditTerm: 'Credit Term',
        receiptDocument: 'Receipt Document',
        creditNote: 'Credit Note',
        paymentType: 'Payment Type',
        paymentDate: 'Payment Date',
        statusPayment: 'Status Payment',
        pleaseSelectInvoice: 'Please select an invoice',
        downloadAllDocuments: 'Download all documents',
        cancel: 'Cancel',
        paymentSummary: 'Payment Summary',
        wht: 'Withholding Tax',
        totalAmount: 'Total Amount',
        boiExemptInfo:
          'This invoice is exempt from withholding tax (WHT) as the company has received BOI tax privileges',
        downloadFile: 'Download File',
        offlinePaymentSteps:
          'If you are unable to make the payment through the system, you may follow these steps:',
        offlineStep1:
          '1. Transfer the payment to Kasikorn Bank account 052-2-41857-9, account name: Internet Thailand Public Company Limited.',
        offlineStep2:
          '2. Log back into the system, upload the payment proof in the “Pending Payments” menu, and click on',
        remark: 'Remark',
        payTo: 'Pay To',
        xPeriods: 'Period(s)',
        discount: 'Discount',
        vat: 'Vat',
        whtContact:
          'If you wish to apply withholding tax (WHT), please contact our staff via email at FNAR-Online@inet.co.th or call 02-257-7179',
        whtAmount: 'Withholding Tax Amount',
        whtAmountThb : 'WHT Amount (THB)',
        submit: 'Submit',
        backToHome: 'Back To Home',
          close: 'Close',
        attachWhtDoc: 'Please attach the withholding tax document',
        fileSizeLimit: 'The file size must not exceed 3.5 MB',
        selectFile: 'Select File',
        noFileUploaded: 'No file uploaded',
        grandTotalThb: 'Grand total (THB)',
        grandTotalNoThb: 'Grand Total',
        fee: 'Fee',
        enterFee: 'Please enter the fee amount',
        paymentAmount: 'Payment Amount',
        enterPaymentAmount: 'Please enter the payment amount',
        paymentBank: 'Payment Bank',
        selectBank: 'Select Bank',
        attachProof: 'Please attach the payment proof',
        amountMismatch: 'The payment amount does not match the total amount',
        uploading: 'Uploading, please wait…',
        pleaseAttachProof: 'Please attach the payment proof',
        uploadSuccess: 'Upload successful',
        pay: 'Pay',
        pendingPayments: 'Pending Payments',
        transactionRefNo: 'Transaction Ref No.',
        totalAmountThb: 'Total Amount (THB)',
        invoicePaymentAmountThb: 'Payment Amount (THB)',
        exportAllExcel: 'Export Excel (all {{count}})',
        billPaymentExporting: 'Exporting...',
        billPaymentExportFailed: 'Export failed. Please try again.',
        lateFeeThb: 'Late Fee (THB)',
        discountThb: 'Discount (THB)',
        vatThb: 'Vat (THB)',
        whtThb: 'Withholding Tax (THB)',
        detail: 'Detail',
        noDataAvailable: 'No Data Available',
        paymentHistory: 'Payment History',
        payAmount: 'Pay Amount',
        paymentMethod: 'Payment Method',
        search: 'Search',
        clear: 'Clear',
        paymentDetail: 'Payment Detail',
        customerCompanyName: 'Customer Company Name',
        description: 'Description',
        to: 'To',
        toDate: 'To',
        paymentProof: 'Payment Proof',
        pendingStatus: 'Pending',
        approvedStatus: 'Approved',
        rejectedStatus: 'Rejected',
        activityHistory: 'Activity History',
        customerManage: 'Customer Manage',
        matching: 'Matching',
        reportMatched: 'Report Matched',
        reportUnmatch: 'Report Unmatch',
        statementOnline: 'Statement Online',
        statement: 'Statement',
        logStatement: 'Log Statement',
        history: 'History',
        logLogin: 'Log Login',
        logDownloadInvoice: 'Log Download Invoice',
        logDownloadReceipt: 'Log Download Receipt',
        logCreditNote: 'Log Credit Note',
        logUpload: 'Log Upload',
        logWht: 'Log Withholding Tax',
        transactions: 'Transactions',
        billPayment: 'Bill Payment',
        offlinePayment: 'Offline Payment',
        userManagement: 'User Management',
        setting: 'Setting',
        pendingVerification: 'Pending',
        uploadRef: 'Upload Ref',
        customerName: 'Customer Name',
        financeOfficer: 'Finance Officer',
        importDate: 'Import Date',
        uploadBy: 'Upload By',
        verify: 'Verify',
        check: 'Check',
        proofOfPaymentDetails: 'Proof of Payment Details',
        whtDocument: 'WHT Document',
        customerID: 'Customer ID',
        grandTotal: 'Grand Total',
        whtPercent: 'WHT (%)',
        feeThb: 'Fee (THB)',
        roundingAmount: 'Rounding Amount',
        roundingCondition: 'Rounding Condition',
        amountExcludeVat: 'Amount Exclude Vat (THB)',
        approve: 'Approve',
        rejectReason:
          'In case of disapproval, please select the reason(s) below. (You may select more than one.)',
        imageUnclear: 'Image is unclear',
        wrongDocument: 'Wrong document uploaded',
        amountMismatchInvoice: 'Payment amount does not match the invoice',
        other: 'Other(s)',
        selectOther: 'Please select “Other” before entering your reason',
        pleaseProvideDetails: 'Please provide details',
        reject: 'Reject',
        approvedSuccessfully: 'Approved Successfully',
        rejectedSuccessfully: 'Rejected Successfully',
        approvedList: 'Approved',
        reverse: 'Reverse',
        approvalDetail: 'Approval Detail',
        reversalDetail: 'Reversal Detail',
        revertApprovedToPending: 'Revert from Approved to Pending',
        enterReason: 'Please enter a reason',
        rejectedList: 'Rejected',
        rejectedDetail: 'Rejected Detail',
        noWhtDoc: 'No withholding tax document uploaded',
        revertRejectedToPending: 'Revert from Rejected to Pending',
        reversalSuccessful: 'Reversal Successful',
        status: 'Status',
        editAt: 'Edit At',
        statusDate: 'Status Date',
        incomingDocument: 'Incoming Document',
        contactInfo: 'Contact Info',
        invoicePaymentType: 'Invoice&Payment Type',
        billingTerms: 'Billing Terms',
        billingType: 'Billing Type',
        billingWithReceipt: 'Billing with Receipt',
        billingAttachments: 'Billing Attachments',
        billingNotes: 'Billing Notes',
        contactInfoDetail: 'Contact Information',
        contactType: 'Contact Type',
        contactName: 'Contact Name',
        phone: 'Phone Number',
        billingRecipient: 'Billing Recipient',
        receiptRecipient: 'Receipt Recipient',
        collectionContact: 'Collection Contact',
        whtContactShort: 'WHT Contact',
        paymentInquiryContact: 'Payment Inquiry Contact',
         totalMatch: 'Total',
         totalThb: 'Total(THB)',
        otherContact: 'Other',
        save: 'Save',
        matchingStatement: 'Matching Statement',
        customerNameTaxID: 'Customer Name / Tax ID',
        searchCustomerNameTaxID: 'Search Customer Name / Tax ID',
        uploadReference: 'Upload Reference',
        searchUploadReference: 'Search Upload Reference',
        bookbankNo: 'Bank/Bookbank No.',
        bookbookbankNo: 'Book/Bookbank No.',
        bankAccountNo: 'Bank Account No.',
        selectBankAccount: 'Select Bank Account',
        total: 'Total',
        depositDate: 'Deposit Date',
        descriptionStatementRef: 'Description/Statement Ref',
        all: 'All',
        match: 'Match',
        unmatch: 'Unmatch',
        partial: 'Partial',
        invoiceAmount: 'Invoice Amount',
        sendEmail:'SEND-EMAIL',
        txnAmount: 'Txn Amount',
        totalSelectedAmount: 'Total Selected Amount',
        statementRef: 'Statement Ref',
        dateTime: 'Date/Time',
        balance: 'Balance',
        detailStatus: 'Detail Status',
        invoiceNoTemplate: 'Invoice No : xx-xxxxxxxx',
        emailReceipt: 'Email Receipt',
        noEmail: 'No Email',
        whtRatePercent: 'WHT Rate (%)',
        invoiceAmountExcludeVat: 'Invoice Amount (Exclude Vat)',
        invoiceGrandTotal: 'Invoice Grand Total (THB)',
        reportMatchedTitle: 'Report Matched',
        thb: 'THB',
        export: 'Export',
        documentRC03No: 'Document RC03 No.',
        statementOnlineTitle: 'Statement Online',
        bank: 'Bank',
        accountNo: 'Account No.',
        selelctAccountNo: 'Selelct Account No.',
        selectStatus: 'Select Status',
        effectiveStartDate: 'Effective Start Date',
        effectiveEndDate: 'Effective End Date',
        actualReceived: 'Actual Received',
        actualPaid: 'Actual Paid',
        amountUsed: 'Amount Used',
        broughtForward: 'Brought forward',
        channel: 'Channel',
        bsNo: 'BS No.',
        rc03: 'RC03',
        chqNo: 'CHQ No.',
        updateBy: 'Update By',
        edit: 'Edit',
        loginHistory: 'Login History',
        downloadPDF: 'Download PDF',
        downloadExcel: 'Download Excel',
        role: 'Role',
        username: 'Username',
        invoiceHistory: 'Invoice History',
        receiptHistory: 'Receipt History',
        creditNoteHistory: 'Credit Note History',
        uploadHistory: 'Upload History',
        orderRef: 'Order Ref',
        transferAmount: 'Transfer Amount',
        transferBank: 'Transfer Bank',
        uploadType: 'Upload Type',
        whtHistory: 'Withholding Tax History',
        type: 'Type',
        billPaymentTitle: 'Bill Payment',
        transactionDate: 'Transaction date',
        offlinePaymentTransactions: 'Offline Payment Transactions',
        pleaseFillInvoiceNo: 'Please fill in the Invoice No',
        userManagementTitle: 'User Management',
        no: 'No.',
        email: 'Email',
        company: 'Company',
        addUser: 'Add User',
        add: 'Add',
        failedAddUser: 'Failed to add user',
        addUserSuccess: 'Successfully added user',
        deleteUserSuccess: 'Successfully deleted user',
        editUser: 'Edit User',
        confirmDelete: 'Are you sure you want to delete this item?',
        yes: 'Yes',
        settingTitle: 'Setting',
        lateFeeAndDiscount: 'Late Fee and Discount',
        lateFee: 'Late Fee',
        registerDiscountedCompany: 'Register Discounted Company',
        adjustMonthlyStatus: 'Adjust Monthly Status',
        changeStatus: 'Change Status',
        statusUpdatedSuccessfully: 'Status updated successfully',
        updateFailed: 'Update failed',
        case: 'Case Management',
        dashboardTitle: 'Operations Dashboard',
        dashboardSubtitle: 'Payment and work queue overview',
        dashboardPaidAmount: 'Successful payment amount',
        dashboardPaidTransactions: 'Successful transactions',
        dashboardPendingEvidence: 'Evidence pending review',
        dashboardRejectedEvidence: 'Rejected evidence',
        dashboardSelectedPeriod: 'Selected period',
        dashboardAllBacklog: 'All current backlog',
        dashboardPaymentTrend: 'Daily payment trend',
        dashboardEvidenceStatus: 'Evidence status',
        dashboardAmount: 'Amount',
        dashboardTransactions: 'Transactions',
        dashboardRefresh: 'Refresh',
        dashboardRetry: 'Retry',
        dashboardSelectCompany: 'Select a company to view dashboard data.',
        dashboardInvalidPeriod: 'Start date must not be after end date.',
        dashboardLoadError: 'Unable to load dashboard data.',
        dashboardCompany: 'Company',
        dashboardLastUpdated: 'Last updated',
      },
      // ▲▲▲ SECTION ที่เพิ่มใหม่ ▲▲▲
    },
  },
  th: {
    translation: {
      navbar: {
        venderCompany: 'บริษัท/ผู้ขาย',
        taxId: 'เลขประจำตัวผู้เสียภาษี',
        custNo: 'หมายเลขลูกค้า',
        custName: 'ชื่อลูกค้า',
      },
  
      app: {
        attachment:'มีเอกสาร',
        sendEmail:'ส่งอีเมล',
         invoicePrepaid: 'ใบแจ้งหนี้/ชำระล่วงหน้า',
         prePaid: 'ชำระเงินล่วงหน้า',
        postPaid: 'ชำระเงินตามรอบบริการ',
        quotationNo: 'เลขที่ใบเสนอราคา',
        service: 'บริการ',
        unpaid: 'ยังไม่ชำระเงิน',
        paid: 'ชำระเงินแล้ว',
        pending: 'รอชำระเงิน',
        overdue: 'เกินกำหนดชำระ',
        eDocuments: 'เอกสารออนไลน์',
        eInvoice: 'ใบแจ้งหนี้อิเล็กทรอนิกส์',
        eReceipt: 'ใบเสร็จรับเงินอิเล็กทรอนิกส์',
        managePayments: 'จัดการการชำระเงิน',
        toPay: 'รายการที่ต้องการชำระ',
        uploadSlip: 'อัปโหลดหลักฐานการชำระเงิน',
        payment: 'การชำระเงิน',
        selected: 'เลือกแล้ว ',
        items: 'รายการ',
        invoiceNo: 'เลขที่ใบแจ้งหนี้',
        period: 'รอบบริการ',
        saleOrder: 'เลขที่ใบสั่งขาย',
        quotation: 'ใบเสนอราคา',
        serviceName: 'ชื่อบริการ',
        invoiceDate: 'วันที่ใบแจ้งหนี้',
        startDate: 'วันที่เริ่มรอบบริการ',
        endDate: 'วันที่สิ้นสุดบริการ',
        dueDate: 'วันที่ครบกำหนดชำระ',
        grandAmountThb: 'ยอดรวมสุทธิ (บาท)',
        creditTerm: 'เงื่อนไขเครดิต',
        receiptDocument: 'เลขที่ใบเสร็จรับเงิน',
        creditNote: 'เอกสารใบลดหนี้',
        paymentType: 'ประเภทการชำระเงิน',
        paymentDate: 'วันที่ชำระเงิน',
        statusPayment: 'สถานะการชำระเงิน',
        pleaseSelectInvoice: 'กรุณาเลือกรายการใบแจ้งหนี้',
        downloadAllDocuments: 'ดาวน์โหลดเอกสารทั้งหมด',
        cancel: 'ยกเลิก',
        paymentSummary: 'สรุปการชำระเงิน',
        toPay: 'รายการที่ต้องการชำระ',
        wht: 'ภาษีหัก ณ ที่จ่าย',
        totalAmount: 'ยอดชำระทั้งหมด',
        boiExemptInfo:
          'กรณีใบแจ้งหนี้ BOI บริษัทฯ ได้รับสิทธิยกเว้นภาษีหัก ณ ที่จ่าย (WHT) จากการส่งเสริมการลงทุน BOI',
        downloadFile: 'ดาวน์โหลดไฟล์',
        offlinePaymentSteps:
          'หากไม่สะดวกชำระเงินผ่านช่องทางในระบบ ท่านสามารถปฏิบัติได้ตามขั้นตอน ดังนี้',
        offlineStep1:
          '1. โอนเงินมาที่ เลขบัญชีธนาคารกสิกรไทย 052-2-41857-9 ชื่อบัญชี บมจ. อินเทอร์เน็ตประเทศไทย',
        offlineStep2:
          '2. กลับเข้าสู่ระบบอีกครั้ง และอัปโหลดหลักฐานการชำระเงินที่เมนู "รายการรอจ่าย" และกดที่',
        remark: 'หมายเหตุ',
        payTo: 'ผู้รับเงิน',
        xPeriods: 'รอบบิล',
        discount: 'ส่วนลด',
        vat: 'ภาษีมูลค่าเพิ่ม',
        whtContact:
          'หากต้องการหักภาษี ณ ที่จ่ายกรุณาติดต่อเจ้าหน้าที่ Email: FNAR-Online@inet.co.th หรือ โทร: 02-257-7179',
        whtAmount: 'จำนวนภาษีหัก ณ ที่จ่าย',
        submit: 'บันทึกรายการชำระเงิน',
        backToHome: 'กลับสู่หน้าหลัก',
        attachWhtDoc: 'แนบเอกสารหักภาษี ณ ที่จ่าย',
        fileSizeLimit: 'ไฟล์ต้องมีขนาดไม่เกิน 3.5MB',
        selectDocument: 'เลือกเอกสาร',
        invoiceNumber: 'เลขที่ใบแจ้งหนี้',
        verifyDocument: 'ตรวจสอบเอกสาร',
        verifyingDocuments: 'กำลังตรวจสอบเอกสาร',
        confirmSubmission: 'ยืนยันการส่ง',
        sendEmailTo: 'ส่งอีเมลไปที่ :',
        emailAttachmentWarning: 'รายการใบแจ้งหนี้จำเป็นต้องมีเอกสารแนบทุกรายการก่อน จึงจะสามารถส่งอีเมลได้',
        sequence: 'ลำดับ',
        documentStatus: 'สถานะเอกสาร',
        noAttachment: 'ไม่มีเอกสารแนบ',
        back: 'ย้อนกลับ',
        close: 'ปิด',
        selectFile: 'เลือกไฟล์',
        noFileUploaded: 'ไม่มีไฟล์ที่อัปโหลด',
        grandTotalThb: 'ยอดรวมสุทธิ (บาท)',
         grandTotalNoThb: 'รวมทั้งหมด',
        bankAccountNo: 'เลขที่บัญชี',
        fee: 'ค่าธรรมเนียม',
        welcome: 'ยินดีต้อนรับ',
        enterFee: 'กรุณากรอกค่าธรรมเนียม',
        paymentAmount: 'จำนวนเงินที่ชำระ',
        enterPaymentAmount: 'กรุณากรอกยอดเงินที่ชำระ',
        paymentBank: 'บัญชีธนาคารผู้รับเงิน',
        selectBank: 'เลือกธนาคาร',
        attachProof: 'แนบหลักฐานการชำระเงิน',
        amountMismatch: 'ยอดชำระเงินไม่ตรงกับยอดรวมทั้งหมด',
        uploading: 'กำลังอัปโหลดโปรดรอสักครู่...',
        pleaseAttachProof: 'กรุณาอัปโหลดหลักฐานการชำระเงิน',
        uploadSuccess: 'อัปโหลดรายการสำเร็จ',
        pay: 'ชำระเงิน',
        pendingPayments: 'รายการรอจ่าย',
        transactionRefNo: 'เลขอ้างอิงรายการ',
           approvedDate: 'วันที่อนุมัติ',
        rejectedDate: 'วันที่ปฏิเสธ',
        totalAmountThb: 'ยอดรวม (บาท)',
        invoicePaymentAmountThb: 'ยอดชำระ (บาท)',
        exportAllExcel: 'Export Excel (ทั้งหมด {{count}} รายการ)',
        billPaymentExporting: 'กำลังส่งออก...',
        billPaymentExportFailed: 'ส่งออกไม่สำเร็จ กรุณาลองอีกครั้ง',
        lateFeeThb: 'ค่าปรับ (บาท)',
        discountThb: 'ส่วนลด (บาท)',
        vatThb: 'ภาษีมูลค่าเพิ่ม (บาท)',
        whtThb: 'ภาษีหัก ณ ที่จ่าย (บาท)',
        detail: 'รายละเอียด',
        noDataAvailable: 'ไม่มีข้อมูล',
        paymentHistory: 'ประวัติการชำระเงิน',
        payAmount: 'ยอดเงินที่ต้องชำระ',
        paymentMethod: 'รูปแบบการชำระเงิน',
        search: 'ค้นหา',
        clear: 'ล้าง',
        paymentDetail: 'รายละเอียดการชำระเงิน',
        customerCompanyName: 'ลูกค้า (บริษัท)',
        description: 'รายละเอียด',
        to: 'ชำระให้แก่',
        paymentProof: 'หลักฐานการชำระเงิน',
        pendingStatus: 'รายการรอตรวจสอบ',
        approvedStatus: 'รายการอนุมัติแล้ว',
         bookbankNoStatment: 'เลขที่บัญชีธนาคาร',
        rejectedStatus: 'รายการปฏิเสธ',
        activityHistory: 'ประวัติการทำรายการ',
        customerManage: 'การจัดการลูกค้า',
        matching: 'การจับคู่รายการ',
        reportMatched: 'รายงานการจับคู่สำเร็จ',
        reportUnmatch: 'รายงานที่ยังไม่ดำเนินการจับคู่',
        statementOnline: 'รายการเดินบัญชี',
        statement: 'รายการเดินบัญชี',
        logStatement: 'ประวัติรายการเดินบัญชี',
        history: 'ประวัติการใช้งาน',
        grandAmount:'ยอดรวมสุทธิ',
        logLogin: 'ประวัติการเข้าสู่ระบบ',
        logDownloadInvoice: 'ประวัติการดาวน์โหลดใบแจ้งหนี้',
        logDownloadReceipt: 'ประวัติการดาวน์โหลดใบเสร็จ',
        logCreditNote: 'ประวัติการออกใบลดหนี้',
        logUpload: 'ประวัติการอัปโหลดเอกสาร',
        logWht: 'ประวัติการหักภาษี ณ ที่จ่าย',
        transactions: 'รายการการชำระเงิน',
        billPayment: 'ชำระผ่านระบบ Payment',
        offlinePayment: 'ชำระเงินผ่านช่องทางอื่น',
        userManagement: 'จัดการผู้ใช้',
        setting: 'การตั้งค่า',
        pendingVerification: 'รายการรอตรวจสอบ',
        uploadRef: 'เลขที่อ้างอิง',
        customerName: 'ชื่อลูกค้า',
        financeOfficer: 'เจ้าหน้าที่การเงิน',
        importDate: 'วันที่อัปโหลดข้อมูล',
        uploadBy: 'อัปโหลดโดย',
        verify: 'ตรวจสอบความถูกต้อง',
        check: 'ตรวจสอบ',
        proofOfPaymentDetails: 'รายละเอียดหลักฐานการชำระเงิน',
        whtDocument: 'เอกสารหัก ณ ที่จ่าย',
        customerID: 'รหัสลูกค้า',
        grandTotal: 'ยอดรวมสุทธิ',
        deleteUserSuccess: 'ลบผู้ใช้สำเร็จ',
        whtPercent: 'ภาษีหัก ณ ที่จ่าย (%)',
        feeThb: 'ค่าธรรมเนียม (บาท)',
        roundingAmount: 'มูลค่าปัดเศษสตางค์',
        roundingCondition: 'เงื่อนไขการปัดเศษ',
        amountExcludeVat: 'มูลค่าก่อนภาษีมูลค่าเพิ่ม',
        whtAmountThb : 'จำนวนภาษีหัก ณ ที่จ่าย (บาท)',
        approve: 'ยืนยันการอนุมัติ',
        rejectReason:
          'ในกรณีที่ไม่อนุมัติ กรุณาเลือกเหตุผลด้านล่าง (สามารถเลือกได้มากกว่า 1 ข้อ)',
        imageUnclear: 'รูปภาพไม่คมชัด',
        wrongDocument: 'รูปภาพไม่ถูกต้อง',
        amountMismatchInvoice: 'จำนวนเงินที่ชำระไม่ตรงตามใบแจ้งหนี้',
        other: 'อื่นๆ',
        selectOther: 'เลือก "อื่นๆ" ก่อนระบุเหตุผล',
        pleaseProvideDetails: 'โปรดระบุ',
        reject: 'ปฏิเสธ',
        approvedSuccessfully: 'อนุมัติสำเร็จ',
        rejectedSuccessfully: 'ปฏิเสธสำเร็จ',
        approvedList: 'รายการอนุมัติแล้ว',
        reverse: 'ย้อนกลับรายการ',
        approvalDetail: 'รายละเอียดการอนุมัติ',
        reversalDetail: 'รายละเอียดการกลับรายการ',
        revertApprovedToPending: 'ย้อนสถานะจากอนุมัติแล้วกลับไปเป็นรออนุมัติ',
        enterReason: 'กรุณากรอกเหตุผล',
        rejectedList: 'รายการปฏิเสธ',
        rejectedDetail: 'รายละเอียดการปฏิเสธ',
        noWhtDoc: 'ไม่มีหลักฐานหักภาษี ณ ที่จ่าย',
        revertRejectedToPending: 'ย้อนสถานะจากปฏิเสธแล้วกลับไปเป็นรออนุมัติ',
        reversalSuccessful: 'กลับรายการสำเร็จ',
        status: 'สถานะ',
        editAt: 'แก้ไขเมื่อ',
        statusDate: 'Status Date',
        incomingDocument: 'Incoming Document',
        amountMoneyThb: 'จำนวนเงิน',
        contactInfo: 'ข้อมูลการติดต่อ',
        invoicePaymentType: 'ประเภทใบแจ้งหนี้และการชำระเงิน',
        billingTerms: 'เงื่อนไขการวางบิล',
        reverseSuccess: 'กลับรายการเสร็จสิ้น',
        billingType: 'วิธีวางบิล',
         addUserSuccess: 'เพิ่มผู้ใช้สำเร็จ',
        billingWithReceipt: 'วางบิลพร้อมใบเสร็จ',
        billingAttachments: 'เอกสารประกอบวางบิล',
        billingNotes: 'หมายเหตุการวางบิล',
        contactInfoDetail: 'ข้อมูลการติดต่อ',
        contactType: 'ประเภทผู้ติดต่อ',
        totalThb: 'ยอดเงินทั้งหมด(THB)',
        contactName: 'ชื่อผู้ติดต่อ',
        phone: 'เบอร์โทรศัพท์',
        email: 'อีเมล',
        sendEmail:'ส่งอีเมล',
          total: 'ยอดเงินทั้งหมด',
         toDate: 'ถึง',
        billingRecipient: 'ผู้รับวางบิล',
        receiptRecipient: 'ผู้รับใบเสร็จ',
        collectionContact: 'ผู้ติดต่อทวงหนี้',
        whtContactShort: 'ติดตามเอกสาร หัก ณ ที่จ่าย',
        paymentInquiryContact: 'สอบถามการชำระ',
        otherContact: 'อื่นๆ',
        save: 'บันทึก',
        matchingStatement: 'รายการจับคู่',
        customerNameTaxID: 'ชื่อลูกค้า/หมายเลขประจำตัวผู้เสียภาษี',
        searchCustomerNameTaxID: 'ค้นหาชื่อลูกค้า/หมายเลขประจำตัวผู้เสียภาษี',
        uploadReference: 'เลขที่อ้างอิง',
        searchUploadReference: 'ค้นหาเลขที่อ้างอิง',
        bookbankNo: 'เลขที่บัญชีธนาคาร',
        bookbookbankNo: 'เลขที่บัญชีธนาคาร',
        selectBankAccount: 'เลือกธนาคาร',
        totalMatch: 'ยอดเงินทั้งหมด',
        depositDate: 'วันที่ฝากเงิน',
        descriptionStatementRef: 'คำอธิบาย/หมายเลขอ้างอิงสเตทเมนต์',
        all: 'ทั้งหมด',
        match: 'ตรงกัน',
        unmatch: 'ไม่ตรงกัน',
        partial: 'แบ่งชำระ',
        invoiceAmount: 'มูลค่าใบแจ้งหนี้',
        txnAmount: 'มูลค่าเงิน',
        totalSelectedAmount: 'ยอดรวมรายการที่เลือก',
        statementRef: 'หมายเลขอ้างอิงสเตทเมนต์',
        dateTime: 'วันที่/เวลา',
        balance: 'ยอดคงเหลือ',
        detailStatus: 'รายละเอียดสถานะ',
        invoiceNoTemplate: 'เลขที่ใบแจ้งหนี้ : xx-xxxxxxxx',
        emailReceipt: 'ส่งใบเสร็จทางอีเมล',
        noEmail: 'ไม่มีเมล',
        whtRatePercent: 'อัตราภาษีหัก ณ ที่จ่าย (%)',
        invoiceAmountExcludeVat: 'มูลค่าใบแจ้งหนี้ (ไม่รวมภาษีมูลค่าเพิ่ม)',
        invoiceGrandTotal: 'ยอดรวมสุทธิ',
        reportMatchedTitle: 'รายงานการจับคู่สำเร็จ',
        thb: 'บาท',
        export: 'บันทึกไฟล์',
        documentRC03No: 'เลขที่เอกสาร RC03',
        statementOnlineTitle: 'รายการเดินบัญชี',
        bank: 'ธนาคาร',
        accountNo: 'เลขที่บัญชีธนาคาร',
        selelctAccountNo: 'เลือกเลขที่บัญชีธนาคาร',
        selectStatus: 'เลือกสถานะ',
        effectiveStartDate: 'วันที่เริ่มมีผล',
        effectiveEndDate: 'วันที่สิ้นสุดมีผล',
        actualReceived: 'รับจริง',
        actualPaid: 'จ่ายจริง',
        amountUsed: 'ยอดใช้ไป',
        broughtForward: 'ยอดยกมา',
        channel: 'ช่องทางการชำระเงิน',
        bsNo: 'เลขที่ BS',
        rc03: 'เลขที่เอกสาร RC03',
        chqNo: 'เลขที่เช็ค',
        updateBy: 'อัปเดตโดย',
        edit: 'แก้ไข',
        loginHistory: 'ประวัติการเข้าใช้งาน',
        downloadPDF: 'ดาวน์โหลดเอกสาร PDF',
        downloadExcel: 'ดาวน์โหลดเอกสาร Excel',
        role: 'สิทธิการใช้งาน',
        username: 'ชื่อผู้ใช้งาน',
        invoiceHistory: 'ประวัติเลขที่ใบแจ้งหนี้',
        receiptHistory: 'ประวัติการดาวน์โหลดใบเสร็จ',
        creditNoteHistory: 'ประวัติการออกใบลดหนี้',
        uploadHistory: 'ประวัติการอัปโหลดเอกสาร',
        orderRef: 'หมายเลขอ้างอิง',
        transferAmount: 'จำนวนยอดเงิน',
        transferBank: 'โอนเงินผ่านธนาคาร',
        uploadType: 'ประเภทการอัปโหลด',
        whtHistory: 'ประวัติการหักภาษี ณ ที่จ่าย',
        type: 'ประเภท',
        billPaymentTitle: 'ชำระผ่านระบบ Payment',
        transactionDate: 'วันที่ทำรายการ',
        paymentMethod: 'รูปแบบการชำระเงิน',
        offlinePaymentTransactions: 'ชำระช่องทาง Offline',
        pleaseFillInvoiceNo: 'กรุณากรอกเลขที่ใบแจ้งหนี้',
        userManagementTitle: 'จัดการผู้ใช้',
        no: 'ลำดับที่',
        email: 'อีเมล',
        company: 'บริษัท',
        addUser: 'เพิ่มผู้ใช้งาน',
        add: 'เพิ่ม',
        failedAddUser: 'เพิ่มผู้ใช้ไม่สำเร็จ',
        editUser: 'แก้ไขผู้ใช้',
        confirmDelete: 'คุณแน่ใจว่าจะลบรายการนี้หรือไม่',
        yes: 'ตกลง',
        settingTitle: 'การตั้งค่า',
        lateFeeAndDiscount: 'ค่าปรับ และ ส่วนลด',
        lateFee: 'ค่าปรับ',
        registerDiscountedCompany: 'เพิ่มบริษัทที่ได้รับส่วนลด',
        adjustMonthlyStatus: 'ปรับสถานะประจำเดือน',
        changeStatus: 'เปลี่ยนสถานะ',
        statusUpdatedSuccessfully: 'ปรับสถานะสำเร็จ',
        updateFailed: 'ปรับสถานะไม่สำเร็จ',
        case: 'จัดการเคส',
        dashboardTitle: 'แดชบอร์ดงานปฏิบัติการ',
        dashboardSubtitle: 'ภาพรวมการรับชำระและคิวงาน',
        dashboardPaidAmount: 'ยอดรับชำระสำเร็จ',
        dashboardPaidTransactions: 'จำนวนรายการรับชำระสำเร็จ',
        dashboardPendingEvidence: 'หลักฐานรอตรวจ',
        dashboardRejectedEvidence: 'หลักฐานถูกปฏิเสธ',
        dashboardSelectedPeriod: 'ตามช่วงวันที่ที่เลือก',
        dashboardAllBacklog: 'งานค้างปัจจุบันทั้งหมด',
        dashboardPaymentTrend: 'แนวโน้มการรับชำระรายวัน',
        dashboardEvidenceStatus: 'สถานะหลักฐานชำระ',
        dashboardAmount: 'ยอดเงิน',
        dashboardTransactions: 'จำนวนรายการ',
        dashboardRefresh: 'รีเฟรช',
        dashboardRetry: 'ลองใหม่',
        dashboardSelectCompany: 'กรุณาเลือกบริษัทเพื่อดูข้อมูล Dashboard',
        dashboardInvalidPeriod: 'วันที่เริ่มต้นต้องไม่มากกว่าวันที่สิ้นสุด',
        dashboardLoadError: 'ไม่สามารถโหลดข้อมูล Dashboard ได้',
        dashboardCompany: 'บริษัท',
        dashboardLastUpdated: 'อัปเดตล่าสุด',
      },
      // ▲▲▲ SECTION ที่เพิ่มใหม่ ▲▲▲
    },
  },
};

const getStoredLanguage = () => {
  if (typeof window === 'undefined') {
    return 'en';
  }

  const storedLanguage = window.localStorage.getItem('i18nextLng') || window.localStorage.getItem('lang');
  return storedLanguage || 'en';
};

const initialLanguage = getStoredLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('i18nextLng', lng);
    window.localStorage.setItem('lang', lng);
  }
});

export default i18n;
